import { createFileRoute } from '@tanstack/react-router';
import type { CpmCollaborationType } from '@/api/product-mapping/types';
import { CpmList } from '@/app/(client)/product-mapping/-components/CpmList';
import { useCpmListController } from '@/app/(client)/product-mapping/-hooks/useCpmListController';

interface Search {
  collaborationType?: CpmCollaborationType | undefined;
  page?: number | undefined;
  limit?: number | undefined;
  sort?: string | undefined;
  filters?: Record<string, string[]> | undefined;
}

export const Route = createFileRoute(
  '/(client)/product-mapping/(pages)/(list)/archive/',
)({
  validateSearch: (search: Record<string, unknown>): Search => ({
    collaborationType:
      (search.collaborationType as CpmCollaborationType) ?? undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
    limit: typeof search.limit === 'number' ? search.limit : undefined,
    sort: typeof search.sort === 'string' ? search.sort : undefined,
    filters: search.filters as Record<string, string[]> | undefined,
  }),
  component: ArchiveProductMappingPage,
});

function ArchiveProductMappingPage() {
  const controller = useCpmListController(true);
  return <CpmList controller={controller} isArchived={true} />;
}
